import axios from './utils/axios';
import { utils } from 'gipsy-misc';

var cancelTokens = {};

export var get = function get() {
  cancelTokens.get = require('axios').CancelToken.source();
  var endpoint = '/mylist/my-schedule';
  return axios.get(endpoint, { cancelToken: cancelTokens.get.token });
};

export var getArchive = function getArchive(lastSortKey, limit, rangeQuery) {
  cancelTokens.getArchive = require('axios').CancelToken.source();
  var endpoint = '/archive/my-tasks';
  var params = {};
  params.lastSortKey = lastSortKey;
  params.limit = limit;
  params.rangeQuery = rangeQuery;
  endpoint = utils.request.appendToUrl(endpoint, params);
  return axios.get(endpoint, { cancelToken: cancelTokens.getArchive.token });
};

export var rescheduleOverload = function rescheduleOverload(date) {
  var endpoint = '/mylist/reschedule-overload/' + date;
  return axios.post(endpoint);
};

export var reschedulePinned = function reschedulePinned(date) {
  var endpoint = '/mylist/reschedule-pinned/' + date;
  return axios.post(endpoint);
};

export var cancel = function cancel(method) {
  if (cancelTokens[method] && cancelTokens[method].cancel) {
    cancelTokens[method].cancel();
  }
};
//# sourceMappingURL=todolist.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-api/lib/todolist.js
// module id = 1089
// module chunks = 0